import React, {useMemo, useCallback} from "react"
import {useDispatch, useSelector} from "react-redux"
import {Transition} from "react-transition-group"

import LeftWorkHeader from "../LeftWorkHeader/LeftWorkHeader"

import {setLeftWorkAreaState} from "../../../redux/actions/product2dActions"

import "./leftworkfonts.scss"

import {fonts} from "../../../constants/utils"

/**
 * Window for choose font family
 * @component
 * @param  {object} props
 * @param  {boolean} props.active - active button state
 *
 * @example
 * const active = false
 *
 * return (
 *  <LeftWorkFonts
 *    active={active}
 *  />
 * )
 */

const LeftWorkFonts = ({active}) => {
  const dispatch = useDispatch()
  const makFabric = useSelector(state => state.makFabric)
  /**
   * Back to edit window
   */
  const backToEdit = () => {
    dispatch(setLeftWorkAreaState("EDIT_TEXT"))
  }
  /**
   * Select font
   * @param {object} e - element
   * @param {object} e.target - target element
   */
  const handleFont = useCallback(
    e => {
      e.preventDefault()
      makFabric.setTextFont(makFabric.getSelectedText(), e.target.name)
    },
    [makFabric],
  )
  /**
   * object with fonts buttons
   */
  const renderFontsBtn = useMemo(
    () =>
      fonts.map(item => (
        <button
          key={item.value}
          className="leftWorkFontsFontBtn"
          name={item.value}
          style={{fontFamily: item.value}}
          onClick={handleFont}
        >
          {item.value}
        </button>
      )),
    [handleFont],
  )

  return (
    <Transition
      in={active}
      timeout={200}
      unmountOnExit={true}
      mountOnEnter={true}
    >
      {state => (
        <div
          className="leftWorkFontsContainer"
          style={{
            ...transitionStyles[state],
          }}
        >
          <LeftWorkHeader
            title="Select Font"
            handler={backToEdit}
            activeHandler={true}
          />
          <div className="leftWorkFontsContent">
            <div className="leftWorkFontsFontBtn_cont">{renderFontsBtn}</div>
          </div>
        </div>
      )}
    </Transition>
  )
}

export default LeftWorkFonts

const transitionStyles = {
  entering: {opacity: 0},
  entered: {opacity: 1, position: "relative"},
  exiting: {opacity: 0},
  exited: {opacity: 0},
}
